import { useLocation, useRouteMatch } from 'react-router-dom';
import { Breadcrumb } from '../components/PageBreadcrumbs/PageBreadcrumbs';
import { ConciergeUrl, baseUrls } from '../constants/urls';
import { conciergeMap, homeBreadcrumb } from '../constants/breadcrumbs';

interface RouteInfo {
  name: ConciergeUrl;
  isExact: boolean;
  path?: string;
  id?: string;
}

const GetRouteInfo = (name: ConciergeUrl): RouteInfo => {
  const routeProps = useRouteMatch<{ requestRef?: string; accountId: string }>(baseUrls[name]);
  const isExact = Boolean(routeProps?.isExact);

  return {
    name,
    path: routeProps?.path,
    isExact,
    id: routeProps?.params?.requestRef || routeProps?.params?.accountId
  };
};

const resolveBreadcrumbs = (breadcrumbs: Breadcrumb[], routeWithId?: RouteInfo) => {
  if (!Array.isArray(breadcrumbs)) return [];

  const tempBreadcrumbs: Breadcrumb[] = [{ ...homeBreadcrumb }, ...breadcrumbs.map((breadcrumb) => ({ ...breadcrumb }))];
  const lastIndex = tempBreadcrumbs.length - 1;

  if (routeWithId?.id) {
    tempBreadcrumbs[lastIndex].title = tempBreadcrumbs[lastIndex].title.replace(':id', routeWithId?.id);
  }
  delete tempBreadcrumbs[lastIndex].url;

  return tempBreadcrumbs;
};

export const usePageBreadcrumbs = (): Breadcrumb[] => {
  const location = useLocation();

  const riskLimitsRequest = GetRouteInfo('riskLimitsRequest');
  const manageAccountLimit = GetRouteInfo('manageAccountLimit');
  const accountChangeRequest = GetRouteInfo('accountChangeRequest');
  const generalRequest = GetRouteInfo('generalRequest');
  const cashMovementRequest = GetRouteInfo('cashMovementRequest');
  const cashMovementNewRequest = GetRouteInfo('cashMovementNewRequest');

  const routesWithId = [manageAccountLimit, riskLimitsRequest, accountChangeRequest, generalRequest, cashMovementRequest, cashMovementNewRequest];
  const routeWithId: RouteInfo | undefined = routesWithId.find((route) => route.isExact);

  const breadcrumbs = conciergeMap[location.pathname] || conciergeMap[routeWithId?.path!];

  return resolveBreadcrumbs(breadcrumbs, routeWithId);
};
